import React, {useState} from "react";
import "./notFound.scss";
import {getMediaPath} from "../../../app/functions";
import dog from "../../../assets/icons/not-found.svg";
import {useSelector} from "react-redux";

const NotFound = (props) => {
    const text = useSelector(store => store.config.Translations);
    return (
        <div className={'not-found-container'}>
            <img className="dog-img" src={getMediaPath(dog)} alt={""}/>
            <h2 className="not-found-title">{text.still_no_results}</h2>
        </div>
    );
}


export default NotFound;







